module.exports = __webpack_public_path__ + "img-dashboard/register/complete-image.10a6ea9b.png";